module.exports = __webpack_public_path__ + "img/HOLLER_ARTWORK_HD.1a3e2378.jpg";